<p>{{ info.companyName }}</p>
<p>{{ info.address }}</p>
<p><strong>Registrikood:</strong> {{ info.regNumber }}</p>
<p><strong>Kontaktnumber:</strong> {{ info.contactPhone }}</p>
<p><strong>Kontakt e-post:</strong> {{ info.contactEmail }}</p>
<p><a class="link" routerLink="/privaatsus">Privaatsus</a> | <a class="link" routerLink="/tingimused">Tingimused</a></p>
